'use strict';

/* Views */
import SurveyEditor from './edit/survey-edit.component';
import SurveyList from './list/survey-list.component';
import SurveyShow from './show/survey-show.component';
import SurveyPublic from './public/survey-public.component';
import SurveyResults from './result/survey-result.component';
import SurveyBrowser from './browser/survey-browser.component';

/* Services */
import SurveysService from '../../services/surveys/surveys.service';
import SurveyResultsService from '../../services/survey-results/survey-results.service';

export default angular.module('conduuApp.surveys', [SurveyEditor, SurveyList, SurveyShow, SurveyResults, SurveyBrowser,
  SurveysService, SurveyResultsService, SurveyPublic])
  .name;



// WEBPACK FOOTER //
// ./client/app/survey/index.js